import { useMemo } from "react";
import { Alert } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useBillingPlanPaidCheck } from "../billing/useSubscription";
import {
	ButtonDropdownMenu,
	type DropdownActionProps,
} from "../components/ButtonDropdownMenu";
import { LinkGen } from "../LinkGen";
import { AppPage } from "../layout/AppLayout";
import { FormPost } from "../post/FormPost";
import { FormPostProvider, useFormPostContext } from "../post/FormPostContext";

export const FormPostConsumer = () => {
	const { handleScheduleClick, handlePublishClick, handleSaveDraftClick } =
		useFormPostContext();
	const isPlanPaid = useBillingPlanPaidCheck();

	const dropdownMenuItems: Array<DropdownActionProps> = useMemo(
		() => [
			{
				label: "Schedule",
				props: { onClick: handleScheduleClick },
			},
			{
				label: "Publish Now",
				props: { onClick: handlePublishClick },
			},
			{
				label: "Save",
				props: { onClick: handleSaveDraftClick, icon: "save" },
			},
		],
		[handleScheduleClick, handlePublishClick, handleSaveDraftClick],
	);

	return (
		<AppPage
			title={"Create Blog Post"}
			headerActions={
				<ButtonDropdownMenu
					main={{
						label: "Schedule",
						props: {
							onClick: handleScheduleClick,
						},
					}}
					options={dropdownMenuItems}
				/>
			}
		>
			<p>
				<Link to={LinkGen.Calendar()}>Back to Calendar</Link>
			</p>
			{!isPlanPaid && (
				<Alert variant="warning">
					Posts are not published if you don't have a plan. Please view the{" "}
					<Link to={LinkGen.Settings.Billing()}>Billing Settings here</Link>!
				</Alert>
			)}
			<FormPost />
		</AppPage>
	);
};

export const PageBlogPostCreate = () => {
	return (
		<FormPostProvider isBlog>
			<FormPostConsumer />
		</FormPostProvider>
	);
};
